var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-4 rounded px-6 ",class:_vm.setBarClass()},[_c('h4',[_vm._v(" "+_vm._s(_vm.notification.message)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }